import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import {
    createStyles,
    Button,
    Collapse,
    Textarea,
    FileInput,
    Text,
    Image,
    FileButton
} from '@mantine/core';
import {
    Dropzone,
    MIME_TYPES,
    IMAGE_MIME_TYPE
} from '@mantine/dropzone';
import {
    DateRangePicker,
    TimeInput
} from '@mantine/dates';

import { ResponsiveCarouselCardB } from '../components/ResponsiveCarouselCardB';

import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';

import {
    fieldInfoUpdated,
    selectSectionData,
    arrayAddition
} from '../features/home/homeSlice';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    }
    
}));


export function CarCreationCardCCompMediaUpload(
    {
        itemName
    }
    ) {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const component_md = {
        par: 'auctions',
        child: 'carCreatorData',
        section: 'mediaGallerySection_6',
    }
    
    //photos videos docs
    //needed:turn this into a switch statement for mimeType and dropZoneMsg
    //needed:ensure mimeTypes are abided by
    const mimeType = itemName == 'photos' ? IMAGE_MIME_TYPE: 'video/*';
    let hasPhotos = itemName.includes('photos');
    const dropZoneMsg = hasPhotos == true ? "Drop Images Here": "Drop Videos Here";
    console.log(`accepting mime type: ${mimeType}`);
    //of_note:later add logic for height and width to emulate a masonry layout
    const mediaGalleryFmt = {
        src: '',
        height: 1,
        width: 1,
    };
    
    const n_Gallery = useSelector(selectSectionData(
        {
            par: component_md['par'],
            child: component_md['child'],
            section: component_md['section'],
            item: itemName,
        }
    ))

    const handleGalleryDrop = (e) => {
        let iGallery = [];
        for (let i = 0; i < e.length; i++){
            let mediaHold = {
                src: URL.createObjectURL(e[i]),
                width: 1,
                height: 1,
                mime: e[i].type,
                origName: e[i].path
            };
            console.log(`mime type:\n\n${mediaHold.mime}`);
            iGallery.push(mediaHold)
        }
        dispatch(carCreatorTextInfoUpdated(
            {
                itemVal: iGallery,
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: itemName
            }
        ));
    }
    
    const [galleryPreview, setGalleryPreviewOpen] = useState(false);
    const onGalleryPreviewOpen = (e) => setGalleryPreviewOpen((o) => !o);
    
    
    return (
        <>
            <Dropzone multiple={true} accept={mimeType} onDrop={handleGalleryDrop} >
                <Text align="center">{dropZoneMsg}</Text>
            </Dropzone>
            <br/>
            {n_Gallery.length > 0 &&
                <>
                    <Button onClick={onGalleryPreviewOpen}>
                        Preview Gallery
                    </Button>
                    <Collapse in={galleryPreview} transitionDuration={1000} transitionTimingFunction="linear">
                        <ResponsiveCarouselCardB incImages={n_Gallery}/>
                    </Collapse>
                </>
                
            }
            <br/>
            <br/>
        
        
        </>
    );
}
